import {
  ActivityMetadata,
  IActivityMetadataShared,
  IActivityMetadataShipmentCreated,
  IActivityMetadataShipmentImported,
  IActivityMetadataCheckInTimeUpdated,
  IActivityMetadataCheckOutTimeUpdated,
  IActivityMetadataStatusUpdated,
} from './activityMetadata'

export enum ActorType {
  dispatcher = 'User',
  driver = 'Driver',
}

export enum EventType {
  SHIPMENT_CREATED = 'v1.shipment_created',
  SHIPMENT_IMPORTED = 'v1.shipment_imported',
  SHIPMENT_SHARED = 'v1.shareable_shared',
  SHIPMENT_STATUS_UPDATED = 'v1.shipment_status_updated',
  SHIPMENT_STATUS_UPDATED_V2 = 'v2.shipment_status_updated',
  SHIPMENT_STATUS_UPDATED_V4 = 'v4.shipment_status_updated',
  SHIPMENT_CHECKIN_TIME_UPDATED = 'v1.shipment_check_in_time_updated',
  SHIPMENT_CHECKOUT_TIME_UPDATED = 'v1.shipment_check_out_time_updated',
}

export interface IActivity {
  id: string
  normalizedActorId: number
  normalizedActorType: ActorType
  actorFullName: string
  eventType: EventType
  // metadata is dependent on eventType
  metadata: ActivityMetadata
  createdAt: string
  date?: string
  // the date without the timestamp, used for grouping
  day?: string
  triggeredByFmsMobile?: boolean
}
export interface IGetActivityResponse {
  activities: IActivity[]
}

// A base type that defines a prop model for Activity Subtext components
export interface IActivitySubtextBaseProps<T extends IActivity = IActivity> {
  activity: T
}

export interface IActivityShared extends IActivity {
  eventType: EventType.SHIPMENT_SHARED
  metadata: IActivityMetadataShared
}

export interface IActivityShipmentCreated extends IActivity {
  eventType: EventType.SHIPMENT_CREATED
  metadata: IActivityMetadataShipmentCreated
}

export interface IActivityShipmentImported extends IActivity {
  eventType: EventType.SHIPMENT_IMPORTED
  metadata: IActivityMetadataShipmentImported
}

export interface IActivityCheckInTimeUpdated extends IActivity {
  eventType: EventType.SHIPMENT_CHECKIN_TIME_UPDATED
  metadata: IActivityMetadataCheckInTimeUpdated
}

export interface IActivityCheckOutTimeUpdated extends IActivity {
  eventType: EventType.SHIPMENT_CHECKOUT_TIME_UPDATED
  metadata: IActivityMetadataCheckOutTimeUpdated
}

export interface IActivityStatusUpdated extends IActivity {
  eventType:
    | EventType.SHIPMENT_STATUS_UPDATED
    | EventType.SHIPMENT_STATUS_UPDATED_V2
    | EventType.SHIPMENT_STATUS_UPDATED_V4
  metadata: IActivityMetadataStatusUpdated
}

export const isActivityShared = (arg?: IActivity): arg is IActivityShared => {
  return arg?.eventType === EventType.SHIPMENT_SHARED
}

export const isActivityShipmentCreated = (arg?: IActivity): arg is IActivityShipmentCreated => {
  return arg?.eventType === EventType.SHIPMENT_CREATED
}

export const isActivityShipmentImported = (arg?: IActivity): arg is IActivityShipmentImported => {
  return arg?.eventType === EventType.SHIPMENT_IMPORTED
}

export const isActivityCheckInTimeUpdated = (
  arg?: IActivity
): arg is IActivityCheckInTimeUpdated => {
  return arg?.eventType === EventType.SHIPMENT_CHECKIN_TIME_UPDATED
}

export const isActivityCheckOutTimeUpdated = (
  arg?: IActivity
): arg is IActivityCheckOutTimeUpdated => {
  return arg?.eventType === EventType.SHIPMENT_CHECKOUT_TIME_UPDATED
}

export const isActivityStatusUpdated = (arg?: IActivity): arg is IActivityStatusUpdated => {
  return (
    arg?.eventType === EventType.SHIPMENT_STATUS_UPDATED ||
    arg?.eventType === EventType.SHIPMENT_STATUS_UPDATED_V2 ||
    arg?.eventType === EventType.SHIPMENT_STATUS_UPDATED_V4
  )
}
